export default "$ vue add vuetify\n";